import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useSignInMutation } from '@src/features/auth/redux';
import { ACCESS_TOKEN_KEY } from '@src/core/config';
import { routesConfig } from '@src/core/routes';
import { ISignInForm } from '@src/features/auth/pages/sign-in-page/types';
import { trackError, toTrackedError } from '@src/core/sentry';

export const useSignInForm = () => {
  const navigate = useNavigate();
  const [signIn, { isLoading }] = useSignInMutation();
  const form = useForm<ISignInForm>();

  const onSubmit = async (data: ISignInForm) => {
    signIn(data).unwrap()
      .then((response) => {
        localStorage.setItem(ACCESS_TOKEN_KEY, response.id_token);
        navigate(routesConfig.app);
      })
      .catch((err: unknown) => {
        trackError(toTrackedError(err), { code: 'FE_0022', extra: { flow: 'signIn' } });
      });
  };

  return {
    ...form,
    onSubmit: form.handleSubmit(onSubmit),
    isLoading,
  };
};

